const Joi = require('joi')

const setDefconLevelSchema = Joi.object({
    defconLvl: Joi.number().integer().min(0).max(5).required().label('Defcon Level'),
    defconMsg: Joi.string().required().label('Defcon Message'),
})

module.exports = setDefconLevelSchema